import { Col, Row } from 'antd';
import { Routes } from 'config/routes';
import { UserRole } from 'gql/types';
import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import SettingsTabs from 'modules/settings/components/SettingsTabs';
import { useCurrentUser } from 'modules/user/hooks/useCurrentUser';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const SettingsPage: FC = () => {
  const { t } = useTranslation('settings.SettingsPage');
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = useCurrentUser();
  const isAdmin = currentUser.data?.role?.value === UserRole.Admin;

  useEffect(() => {
    if (location.pathname === Routes.Settings) {
      // Non-admin users only see the Notifications tab
      navigate(
        isAdmin ? Routes.SettingsGeneral : Routes.SettingsNotifications,
        { replace: true }
      );
    }
  }, [location, isAdmin]);

  return (
    <ProfileSideMenuWrapper title={t('settings')}>
      <Row gutter={[10, 10]} justify="space-between">
        <Col span={24}>
          <SettingsTabs />
        </Col>
      </Row>
    </ProfileSideMenuWrapper>
  );
};

export default SettingsPage;
